<template>
<div class="chapter">
<div class="inner_page">
<p class="image1"><img alt="images" src="images/page09_fig01.jpg"/></p>
<p class="imgcaption">A classic Charlotte street scene from its trolley era. Charlotte was built on business and liked new technology, such as the electric streetcar. <i>Courtesy of the Robinson-Spangler Carolina Room of the Public Library of Charlotte and Mecklenburg County</i>.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter.vue?7374ded6